export default {"src":"/_next/static/media/frame4.042a4a7d.svg","height":110,"width":226,"blurWidth":0,"blurHeight":0};